import React from 'react'
import MediaQuery from 'react-responsive'

import { useRemoteStrings } from '@acorns/web-utils'

import DirectToMobileImage from 'assets/images/direct-to-mobile-image.svg'
import CenteredSpinner from 'components/CenteredSpinner'
import Nav from 'components/Nav'

import { TestIDs } from '../../test/utils/testIds'
import { enhance } from './enhance'
import {
  ActionWrapper,
  DownloadNowImage,
  ImageAndTextContainer,
  ImageContainer,
  LayoutContents,
  Message,
  PageContainer,
  StyledLayout,
  StyledSeparator,
  TextContainer,
  Title,
} from './styled-components'
import { TrackedDownloadAppButton } from './TrackedDownloadAppButton'
import { InnerProps } from './types'

const DirectToMobileLander: React.FunctionComponent<InnerProps> = ({ heroText, loading }) => {
  const { getRemoteString, isLoadingRemoteStrings } = useRemoteStrings()

  const title = getRemoteString({ key: 'direct_to_mobile.success_lander.title' }) ?? heroText.text
  const subtitle =
    getRemoteString({ key: 'direct_to_mobile.success_lander.subtitle' }) ?? heroText.subtext

  const isLoading = loading || isLoadingRemoteStrings

  return (
    <>
      <PageContainer>
        {isLoading && <CenteredSpinner />}
        {!isLoading && <PageContents title={title} subtitle={subtitle} />}
      </PageContainer>
    </>
  )
}

const PageContents = ({ title, subtitle }) => (
  <>
    <Nav />
    <StyledLayout>
      <LayoutContents>
        <ImageAndTextContainer>
          <ImageContainer>
            <DownloadNowImage src={DirectToMobileImage} alt="Download Acorns Image" />
          </ImageContainer>
          <TextContainer>
            <Title data-testid={TestIDs.DIRECT_TO_MOBILE.DOWNLOAD_ACORNS_TITLE}>{title}</Title>
            <Message data-testid={TestIDs.DIRECT_TO_MOBILE.DOWNLOAD_ACORNS_MESSAGE}>
              {subtitle}
            </Message>
          </TextContainer>
        </ImageAndTextContainer>
        <StyledSeparator />
        <ActionWrapper>
          <MediaQuery maxWidth={500}>
            <TrackedDownloadAppButton />
          </MediaQuery>
          <MediaQuery minWidth={501}>
            <TrackedDownloadAppButton isTablet={true} />
          </MediaQuery>
        </ActionWrapper>
      </LayoutContents>
    </StyledLayout>
  </>
)

export default enhance(DirectToMobileLander)
